import GoogleMapReact from "google-map-react"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import { mapOptions } from "./utils/mapOptions"

const apiKey = process.env.GOOGLE_MAPS_API_KEY

const StyledMapContainer = styled.div`
  margin-top: 148px;
  margin-bottom: 20px;
  position: relative;
  background: ${(p) => p.theme.colors.nonExistentLightBlue};
  svg {
    width: 100%;
    height: 100%;
    pointer-events: none;
    path {
      outline: none;
    }
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-bottom: 0;
    background-image: linear-gradient(to right, #e4eef8 80%, white);
  }
`

type DynamicMapProps = {
  setMaps: Dispatch<any>
  setMap: Dispatch<SetStateAction<google.maps.Map>>
}
const DynamicMap = ({ setMaps, setMap }: DynamicMapProps) => {
  return (
    <StyledMapContainer aria-label="מפה, ניתן לנווט עם חצי המקלדת">
      <GoogleMapReact
        bootstrapURLKeys={{
          key: apiKey,
          language: "iw",
          libraries: ["geometry"],
        }}
        options={mapOptions}
        defaultCenter={{ lat: 31.739798850747462, lng: 34.557425805228085 }}
        defaultZoom={7}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => {
          setMap(map as google.maps.Map)
          setMaps(maps)
        }}
      />
    </StyledMapContainer>
  )
}

export default DynamicMap
